import React from 'react'
import Link from 'gatsby-link'

import ww_logo from '../assets/imgs/w.png'

const Header = ({ siteTitle }) => (
    <div>
        <nav id="header-nav" className="">
            <div className="site-width">
                <div className="row">
                    <div className="small-2 columns">
                        <span id="logo">
                            <img
                                src={ww_logo}
                                height="20"
                                width="50"
                                title="wataru watanabe // web developer"
                            />
                        </span>
                    </div>
                    <div className="small-10 columns" />
                </div>
            </div>
        </nav>
    </div>
)

export default Header
